import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "Mahaview Enterprises transformed our online presence completely. Their web development team delivered a stunning website that increased our conversions by 40%. Highly professional and reliable.",
    name: "Rajesh Sharma",
    role: "CEO, TechVista Solutions",
    avatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150",
  },
  {
    quote:
      "The social media management and graphic design services from Mahaview have been exceptional. Our brand engagement has grown significantly, and their creative work consistently impresses.",
    name: "Priya Mehta",
    role: "Marketing Director, BluLeaf Studios",
    avatar: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150",
  },
  {
    quote:
      "Their live streaming expertise is unmatched. Mahaview handled our annual corporate conference seamlessly with professional multi-camera setup and zero technical issues.",
    name: "Amit Patel",
    role: "Founder, EventStream India",
    avatar: "https://images.pexels.com/photos/697509/pexels-photo-697509.jpeg?auto=compress&cs=tinysrgb&w=150",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-20 md:py-32 px-5 sm:px-6 md:px-10 border-t border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16 grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-7 min-w-0">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-4 md:mb-5">/ Testimonials</div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-6xl font-semibold leading-[1.05] tracking-tight break-words">
              What our<br />
              clients <span className="text-[#FF5A00]">say.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="mv-card p-7 md:p-8 flex flex-col gap-6"
            >
              <Quote size={26} className="text-[#FF5A00]" strokeWidth={1.5} />
              <blockquote className="text-base text-zinc-200 leading-relaxed font-display font-medium">
                {t.quote}
              </blockquote>
              <figcaption className="mt-auto pt-6 border-t border-white/10 flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover border border-white/20"
                />
                <div>
                  <div className="text-sm font-medium text-white">{t.name}</div>
                  <div className="text-[10px] text-zinc-400 uppercase tracking-[0.2em] mt-1">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
